module.exports = __webpack_public_path__ + "static/integration/img/ally-icon.036281fadcb78861777fac63a39d8eaf.png";